import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Raffle.module.css";
import clock from "/clockicon.svg";
import character from "/character-icon.svg";
import telegramNFT from "/telegramNFT.svg";
import coin from "/dreamcoin-logo.svg";
import spin from "/spin.svg";
import { RaffleData } from "../../../../adapters/RaffleAdapter";
import { TimeDisplay } from "../../../../../utils/TimeDisplay";


interface RaffleCardProps {
  raffle: RaffleData;
}

function formatNumber(num: number): string {
  return num.toLocaleString("en-US");
}

export const RaffleCard: React.FC<RaffleCardProps> = React.memo(({ raffle }) => {
  const navigate = useNavigate();
  const rarityTranslations = {
    Common: "Обычный",
    Uncommon: "Необычный",
    Rare: "Редкий",
    Epic: "Эпический",
    Legendary: "Легендарный",
    Default: "Стандартный",
    Special: "Особый",
  };
  console.log(raffle);
  const renderPrize = React.useCallback((prize: RaffleData["short_prizes"][0]) => {
    if (prize.type === "Character") {
      return (
        <div className={styles.characterPrize}>
          <span className={styles.characterRarity}>
            {
              rarityTranslations[
                prize.item_type as keyof typeof rarityTranslations
              ]
            }
          </span>
          <img src={character} alt="character" />
        </div>
      );
    }
    if (prize.type === "TelegramNFT") {
      return (
        <div className={styles.telegramNFTPrize}>
          <span>Подарки</span>
          <img className={styles.telegramNFT} src={telegramNFT} alt="telegramNFT" />
        </div>
      );
    }
    return (
      <div className={styles.currencyPrize}>
        <span className={styles.prizeAmount}>
          {formatNumber(prize.amount)} {prize.type}
        </span>
        <img src={prize.type === "DC" ? coin : spin} alt="coin" />
      </div>
    );
  }, []);


  return (
    <div
      className={styles.raffleItem}
      onClick={() => navigate(`/giveaway/${raffle.id}`)}
    >
      <div
        className={styles.raffleBackground + ' ' + (raffle.short_prizes[0].type === 'TelegramNFT' ? styles.raffleBackgroundNFT : '')}
        style={{ backgroundImage: `url(${raffle.background})` }}
      ></div>
      <div className={styles.raffleContent}>
      <div className={styles.raffleTimer}>
      <img src={clock} alt="clock" />
      {raffle.status === "winner_selection" ? (
            "Выбор победителя..."
          ) : (
            <>
              <TimeDisplay endDate={raffle.date_end} format="short" />
            </>
          )}
    </div>
        <div className={styles.rafflePrizes}>
          {raffle.short_prizes.map((prize, index) => (
            <div key={index} className={styles.prizeItem}>
              {renderPrize(prize)}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
});
